import { CommissionRuleMethod } from 'gen/ApiClient';

export const calculateCommissionX = (priceExVat: number, priceDevicesExVat: number, ruleMethod: CommissionRuleMethod, rulePercentage: number) => {
	const baseAmount = ruleMethod === 'TotalValueOfSale' ? priceExVat : priceDevicesExVat;
	return (rulePercentage / 100) * baseAmount;
};
